import React, { useCallback } from 'react';
import { Button, makeStyles, Theme } from '@material-ui/core';
import { CloseButtonProps } from 'components/Notifier/type';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: '#ffffff',
  },
}));

function CloseButton({ key }: CloseButtonProps) {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();

  const onClose = useCallback(() => {
    closeSnackbar(key);
  }, [key, closeSnackbar]);

  return (
    <Button className={classes.root} key={key} onClick={onClose}>
      닫기
    </Button>
  );
}

export default CloseButton;
